import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Roles } from './core/ucr-security/roles';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { MaintenanceComponent } from './registrar/admin/maintenance/maintenance.component';
import { RegistrarAdminMenuAuthGuardService } from './registrar/admin/registrar-admin-menu-auth-guard.service';
import { RegistrarMenuAuthGuardService } from './registrar/registrar-menu-auth-guard.service';
import { RegistrarComponent } from './registrar/registrar.component';
import { AddStudentComponent } from './roster/add-student/add-student.component';
import { DownloadGradesComponent } from './roster/download-grades/download-grades.component';
import { HelpComponent } from './roster/help/help.component';
import { UploadGradesComponent } from './roster/upload-grades/upload-grades.component';
import { EditStudentComponent } from './roster/edit-student/edit-student.component';
import { EmailClassComponent } from './roster/email-class/email-class.component';
import { ViewLogComponent } from './roster/view-log/view-log.component';
import { AuthGuardService } from './shared/services/auth-guard.service';
import { RosterComponent } from './roster/roster.component';
import { RosterMenuAuthGuardService } from './roster/roster-menu-auth-guard.service';
import { IpGradeRegistrarComponent } from './registrar/staff/ip-grade-registrar/ip-grade-registrar.component';
import { CourseListRegistrarComponent } from './registrar/staff/course-list-registrar/course-list-registrar.component';
import { RegistrarStaffMenuAuthGuardService } from './registrar/staff/registrar-staff-menu-auth-guard.service';
import { NotFoundComponent} from "./not-found/not-found.component";

export const rootRouterConfig: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: 'home',
        data: { mobileTitle: 'Mobile Title', breadcrumb: 'Home' }, // todo: change mobileTitle
        children: [
            {
                path: '',
                component: MainMenuComponent,
                canActivate: [AuthGuardService],
                data: {
                    breadcrumb: undefined,
                    anyRoles: [
                        Roles.instructor,
                        Roles.departmentAdministrator,
                        Roles.registrarStaff,
                        Roles.registrarAdmin,
                        Roles.siteAdmin,
                        Roles.appAdmin
                    ]
                }
            },
            {
                path: 'registrar',
                component: RegistrarComponent,
                canActivate: [RegistrarMenuAuthGuardService],
                data: { breadcrumb: 'Registrar' },
                children: [
                    {
                        path: 'maintenance',
                        component: MaintenanceComponent,
                        canActivate: [RegistrarAdminMenuAuthGuardService],
                        data: { breadcrumb: 'Maintenance' }
                    },
                    {
                        path: 'ip-grade',
                        component: IpGradeRegistrarComponent,
                        canActivate: [RegistrarStaffMenuAuthGuardService],
                        data: { breadcrumb: 'IP Grading' }
                    },
                    {
                        path: 'reports',
                        component: CourseListRegistrarComponent,
                        canActivate: [RegistrarStaffMenuAuthGuardService],
                        data: { breadcrumb: 'Report' }
                    }
                ]
            },
            {
                path: 'roster/:termCode/:crn',
                canActivate: [RosterMenuAuthGuardService],
                data: { breadcrumb: 'Roster' },
                children: [
                    {
                        path: '',
                        component: RosterComponent,
                        data: { breadcrumb: 'View' }
                    },
                    {
                        path: 'downloadRoster',
                        component: DownloadGradesComponent,
                        data: { breadcrumb: 'Download Roster' }
                    },
                    {
                        path: 'uploadGrades',
                        component: UploadGradesComponent,
                        data: { breadcrumb: 'Upload Grades' }
                    },
                    {
                        path: 'addStudent',
                        component: AddStudentComponent,
                        data: { breadcrumb: 'Add Student' }
                    },
                    {
                        path: 'editStudent',
                        component: EditStudentComponent,
                        data: { breadcrumb: 'Edit Student' }
                    },
                    {
                        path: 'emailClass',
                        component: EmailClassComponent,
                        data: { breadcrumb: 'Email Class' }
                    },
                    {
                        path: 'viewLog',
                        component: ViewLogComponent,
                        data: { breadcrumb: 'View Log' }
                    },
                    {
                        path: 'help',
                        component: HelpComponent,
                        data: { breadcrumb: 'Help' }
                    }
                ]
            },
            {
                path: 'staff-reports',
                canActivate: [AuthGuardService],
                component: CourseListRegistrarComponent,
                data: {
                    breadcrumb: 'Report',
                    mobileTitle: 'Report',
                    anyRoles: [Roles.departmentAdministrator]
                }
            },
            {
                path: 'site-admin',
                loadChildren: () => import('./site-admin/site-admin.module').then((m) => m.SiteAdminModule),
                canActivate: [AuthGuardService],
                data: {
                    breadcrumb: 'Site Admin',
                    mobileTitle: 'Site Admin',
                    anyRoles: [Roles.siteAdmin, Roles.appAdmin]
                }
            },

        ]
    },
    { path: 'login', component: LoginComponent, data: { mobileTitle: 'Sign In' } },
    { path: 'logout', component: LogoutComponent, data: { mobileTitle: 'Signed Out' } },
    { path: 'notAuthorized', component: NotAuthorizedComponent, data: { mobileTitle: 'Not Authorized' } },
    { path: '**', component: NotFoundComponent, data: { mobileTitle: 'Not Found' } }
];

@NgModule({
    imports: [
        RouterModule.forRoot(rootRouterConfig, {
            enableTracing: false
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
